module.exports = __webpack_public_path__ + "img/旭瑞智能化灌溉系统管理平台V1.0.b91cfb0c.jpg";